import React from 'react';
import { FileText } from 'lucide-react';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';
import { computeInvoice, money } from '../../lib/invoice';

export const InvoiceBreakdown = ({ calc, idPrefix }) => (
  <div className="mt-2 bg-black/40 rounded-lg p-2 text-xs space-y-0.5" data-testid={`${idPrefix}-invoice-breakdown`}>
    <div className="flex justify-between text-gray-400"><span>Subtotal (sin IVA)</span><span data-testid={`${idPrefix}-invoice-base`}>{money(calc.base)}</span></div>
    <div className="flex justify-between text-gray-400"><span>IVA 8%</span><span data-testid={`${idPrefix}-invoice-iva`}>+{money(calc.iva)}</span></div>
    {calc.isr > 0 && (
      <div className="flex justify-between text-amber-400"><span>Retención ISR 1.25%</span><span data-testid={`${idPrefix}-invoice-isr`}>-{money(calc.isr)}</span></div>
    )}
    <div className="flex justify-between text-sky-300 font-bold pt-1 border-t border-gray-700">
      <span>Total a cobrar</span><span data-testid={`${idPrefix}-invoice-total`}>{money(calc.total)}</span>
    </div>
  </div>
);

export const InvoiceToggle = ({ value, gross, onChange, onCommit, idPrefix, disabled = false }) => {
  const set = (patch, commit) => {
    const next = { ...value, ...patch };
    onChange(next);
    if (commit && onCommit) onCommit(next);
  };
  return (
    <div className="bg-sky-900/15 border border-sky-500/30 rounded-xl p-2" data-testid={`${idPrefix}-invoice-panel`}>
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-2 text-sky-300 text-xs font-semibold">
          <FileText className="h-3.5 w-3.5" /> Requiere factura
        </span>
        <Switch
          className="data-[state=checked]:bg-sky-500 data-[state=unchecked]:bg-gray-700"
          checked={!!value.requires_invoice}
          disabled={disabled}
          onCheckedChange={(v) => set({ requires_invoice: v }, true)}
          data-testid={`${idPrefix}-invoice-toggle`}
        />
      </div>
      {value.requires_invoice && (
        <>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <Input
              value={value.rfc || ''}
              maxLength={13}
              disabled={disabled}
              onChange={(e) => set({ rfc: e.target.value.toUpperCase() })}
              onBlur={() => onCommit && onCommit(value)}
              placeholder="RFC del cliente"
              className="bg-black/50 border-gray-700 text-white h-8 text-sm font-mono uppercase"
              data-testid={`${idPrefix}-invoice-rfc`}
            />
            <Input
              value={value.razon_social || ''}
              disabled={disabled}
              onChange={(e) => set({ razon_social: e.target.value })}
              onBlur={() => onCommit && onCommit(value)}
              placeholder="Razón social (opcional)"
              className="bg-black/50 border-gray-700 text-white h-8 text-sm"
              data-testid={`${idPrefix}-invoice-razon`}
            />
          </div>
          <div className="flex items-center justify-between mt-2 text-xs text-gray-300">
            <span>Retener ISR 1.25% (según régimen del cliente)</span>
            <Switch
          className="data-[state=checked]:bg-sky-500 data-[state=unchecked]:bg-gray-700"
              checked={!!value.apply_isr}
              disabled={disabled}
              onCheckedChange={(v) => set({ apply_isr: v }, true)}
              data-testid={`${idPrefix}-invoice-isr-toggle`}
            />
          </div>
          <InvoiceBreakdown calc={computeInvoice(gross, value.apply_isr)} idPrefix={idPrefix} />
        </>
      )}
    </div>
  );
};
